/* eslint-disable */
import axios from "axios";
import Noty from "noty";
import "noty/lib/noty.css";
import "noty/lib/themes/bootstrap-v3.css";
import qs from "querystring";

let BASEURL = "";
let NOTIFICATION_URL = "";
let IOT_URL = "";
let GRAPH_URL = "";
let AUTH_URL = "";
let FastAPI_URL = "";
export let ONBOARDING_URL = "";
export let PARTNER_URL = "";
export let FINANCE_URL = "";
const isLocalDev = true;
switch (window.location.host) {
  case "uat.arnergy.com":
    BASEURL = "https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL =
      "https://ii4470x4p8.execute-api.us-west-2.amazonaws.com/prod";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL =
      "https://uc34sin7hjr47dvoufi34qph2u0qbskd.lambda-url.us-east-1.on.aws/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    PARTNER_URL = "https://api2.arnergy.com/partners/api/v1";
    ONBOARDING_URL = `https://api2.arnergy.com/prod/customer-onboarding/api`;
    FINANCE_URL = `https://api2.arnergy.com/payments/api/v1/`;
    break;
  case "solarbase-staging.arnergy.com":
    BASEURL = "https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL =
      "https://ii4470x4p8.execute-api.us-west-2.amazonaws.com/prod";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL =
      "https://uc34sin7hjr47dvoufi34qph2u0qbskd.lambda-url.us-east-1.on.aws/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    AUTH_URL = "https://api2.arnergy.com/prod/auth/api/v1";
    ONBOARDING_URL = `https://api2.arnergy.com/prod/customer-onboarding/api`;
    break;
  case "dev1.arnergy.com":
    BASEURL = "https://solarbase-temp-env-3.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL =
      "https://2h3ip9wikd.execute-api.eu-west-2.amazonaws.com/dev/api/v1/configuration";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL =
      "https://uc34sin7hjr47dvoufi34qph2u0qbskd.lambda-url.us-east-1.on.aws/dev";
    FastAPI_URL = "https://api2.arnergy.com/dev/iot-handler/";

    ONBOARDING_URL = `https://api2.arnergy.com/dev/customer-onboarding/api`;
    AUTH_URL = "https://api2.arnergy.com/dev/auth/api/v1";
    PARTNER_URL = "https://api2.arnergy.com/dev/partners-platform/api/v1";
    FINANCE_URL = "https://api2.arnergy.com/dev/payments/api/v1/";
    break;
  case "localhost:3001":
    // case "localhost:8080":
    BASEURL = "https://api-solarbase.arnergy.com";
    // BASEURL = "http://localhost:3000" //or 8000;
    // BASEURL = "https://solarbase-temp-env-3.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL =
      "https://2h3ip9wikd.execute-api.eu-west-2.amazonaws.com/dev/api/v1/configuration";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://9cwdo1u2ih.execute-api.us-east-1.amazonaws.com/dev";
    // FastAPI_URL = "http://127.0.0.1:8000";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    // FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    // ONBOARDING_URL = `https://api2.arnergy.com/dev/customer-onboarding/api`;
    ONBOARDING_URL = `https://api2.arnergy.com/prod/customer-onboarding/api`;
    // ONBOARDING_URL = `http://127.0.0.1:8000/api`;
    // FastAPI_URL = "https://api2.arnergy.com/dev/iot-handler/";
    AUTH_URL = "https://api2.arnergy.com/dev/auth/api/v1";
    // AUTH_URL = "http://127.0.0.1:8000/api/v1";
    // PARTNER_URL = "http://127.0.0.1:8721/api/v1";
    // PARTNER_URL = "https://api2.arnergy.com/dev/partners-platform/api/v1";
    PARTNER_URL = "https://api2.arnergy.com/partners/api/v1";
    FINANCE_URL = "https://api2.arnergy.com/dev/payments/api/v1/"; //`http://localhost:8000/api/v1/`;
    break;
  // BASEURL = "https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com";
  // https://uat.arnergy.com
  default:
    ONBOARDING_URL = `https://api2.arnergy.com/prod/customer-onboarding/api`;
    BASEURL = "https://api-solarbase.arnergy.com";
    NOTIFICATION_URL =
      "https://ii4470x4p8.execute-api.us-west-2.amazonaws.com/prod";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://9cwdo1u2ih.execute-api.us-east-1.amazonaws.com/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    PARTNER_URL = "https://api2.arnergy.com/partners/api/v1";
    AUTH_URL = "https://api2.arnergy.com/prod/auth/api/v1";
    FINANCE_URL = `https://api2.arnergy.com/payments/api/v1/`;
    break;
}

const instance = axios.create({
  baseURL: `${BASEURL}/api/v1/`,
  timeout: 0,
  headers: {
    "Content-Type": "application/json"
  }
});
const explorerHTTP = axios.create({
  baseURL: `${BASEURL}/explorer/swagger.json`,
  timeout: 0,
  headers: {
    "Content-Type": "application/json"
  }
});

const ZOHOTHTTP = axios.create({
  baseURL: `${BASEURL}/api/v1/zohos/`
});

const FASTHTTP = axios.create({
  baseURL: ONBOARDING_URL,
  // baseURL: `http://127.0.0.1:8000/api`,
  // baseURL: `https://api2.arnergy.com/dev/customer-onboarding/api`,
  // baseURL: `https://api2.arnergy.com/prod/customer-onboarding/api`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json"
  }
});

const AUTHHTTP = axios.create({
  baseURL: AUTH_URL,
  // baseURL: `http://127.0.0.1:8000/api`,
  // baseURL: `https://api2.arnergy.com/dev/customer-onboarding/api`,
  // baseURL: `https://api2.arnergy.com/prod/customer-onboarding/api`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json"
  }
});

const PartnerHTTP = axios.create({
  baseURL: PARTNER_URL,
  // baseURL: `http://127.0.0.1:8000/api`,
  // baseURL: `https://api2.arnergy.com/dev/customer-onboarding/api`,
  // baseURL: `https://api2.arnergy.com/prod/customer-onboarding/api`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json"
  }
});

const NotificationHTTP = axios.create({
  baseURL: `${NOTIFICATION_URL}`
});

const GraphHTTP = axios.create({
  baseURL: `${GRAPH_URL}`
});

const AlarmHTTP = axios.create({
  // Staging
  baseURL: `https://api2.arnergy.com/dev/alarms`
  // Production
  // baseURL: `https://api2.arnergy.com/prod/alarms`
});

const FastAPIHTTP = axios.create({
  baseURL: `${FastAPI_URL}`
});

const IOTHTTP = axios.create({
  baseURL: `${IOT_URL}/api/v1/`
});

const LUXHTTP = axios.create({
  baseURL: `https://api2.arnergy.com/prod/lux/api/v1`
});

const CacheHTTP = axios.create({
  // baseURL: "http://localhost:5000"
  baseURL: "https://api2.arnergy.com/cache"
});

const FINANCE_HTTP = axios.create({
  baseURL: FINANCE_URL,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json"
  }
});
instance.interceptors.request.use(function(config) {
  const token = localStorage.getItem("appUserToken");
  config.headers.Authorization = token;

  return config;
});

// FASTHTTP.interceptors.request.use(function(config) {
//   const token = localStorage.getItem("appUserToken");
//   if (token) {
//     config.headers.Authorization = token;
//   }

//   return config;
// });

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.code == "AUTHORIZATION_REQUIRED"
    ) {
      if (!window.location.pathname.includes("onboarding")) {
        new Noty({
          theme: "bootstrap-v3",
          text: "Unauthorized access, please login",
          type: "error"
        }).show();
        logout();
      }
    } else {
      return Promise.reject(error);
    }
  }
);

PartnerHTTP.interceptors.request.use(function(config) {
  const token = localStorage.getItem("partnerAPIKey");
  const partnerRole = localStorage.getItem("roleType");
  config.headers["x-api-key"] = token;
  config.headers["x-user-role"] = partnerRole;

  return config;
});

const logout = () => {
  localStorage.clear();
  // @todo: clear store data
  setTimeout(() => {
    window.location.href = "/auth/login";
    // this.$router.replace({ path: "/auth/login" });
  }, 100);
};

const addHeaders = Obj => {
  Object.keys(Obj).forEach(key => {
    switch (key.toLowerCase()) {
      case "content-type":
        instance.defaults.headers.post[key] = Obj[key];
        break;
      default:
        instance.defaults.headers.common[key] = Obj[key];
    }
  });
};
// This object is included to exposes custom transforms
// and flatten nested objects for specific requests.
const flatten = {
  // this function flattens and transforms the /devices/list request
  deviceList: datum =>
    datum.map(data => {
      const user = data.user.data;
      const fullName = `${user.first_name} ${user.last_name}`;
      const others = data;
      delete others.user;
      return Object.assign({}, others, user, {
        fullName
      });
    })
};

const queryStrings = params => qs.stringify(params);

export default {
  addHeaders,
  queryStrings,
  instance,
  explorerHTTP,
  ZOHOTHTTP,
  flatten,
  NotificationHTTP,
  IOTHTTP,
  LUXHTTP,
  AlarmHTTP,
  GraphHTTP,
  FastAPIHTTP,
  CacheHTTP,
  FASTHTTP,
  PartnerHTTP,
  AUTHHTTP,
  FINANCE_HTTP
};


// WEBPACK FOOTER //
// ./src/utils/http-common.js